import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import {
  FulfillmentGroupData,
  getSelectedRate,
} from "@redotech/redo-fulfillment-group-common/fulfillment-group";

export const USPSZoneCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "USPS zone",
    cell: (row) => {
      const rate = getSelectedRate({
        selectedShippingRate: row.selectedShippingRate,
        availableRates: row.availableShipmentRates?.rates,
      });
      return rate?.usps_zone ? String(rate.usps_zone) : "";
    },
  };
